export const trackPageViewServerSide = async (url, userAgent, referrer) => {
  try {
    // Matomo API volání nebo jiné sledování
    const response = await fetch('/api/matomo', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        url,
        userAgent,
        referrer,
      }),
    });
    return response;
  } catch (error) {
    console.error('Failed to track page view:', error);
  }
};